import { MessageSquareText, Star } from 'lucide-react';
import { InstructorsBody } from 'modules/arena/reports/model/bodies';
import { formatDate } from 'modules/arena/reports/model/dates';
import { formatCount, formatRating } from 'modules/arena/reports/model/format';
import { Panel } from 'modules/arena/reports/components/Panel';
import { DataTable } from 'modules/arena/reports/components/DataTable';
import { AreaProps } from 'modules/arena/reports/areas/shared';

export function InstructorsArea({ body, controller }: AreaProps<InstructorsBody>) {
  const { changeTable, tableLoading } = controller;
  return (
    <div className="flex flex-col gap-6">
      <p className="rounded-xl border border-border/60 bg-surface px-4 py-3 text-sm text-ink">
        Escala de 1 a {body.scale}. O ranking por nota considera só quem tem pelo menos <strong>{body.minimumSample} avaliações</strong> no
        período; os demais aparecem como “amostra insuficiente”. Use “Ordenar por” para ver melhor avaliado, mais avaliado e maior
        atividade — são rankings diferentes, calculados sobre todos os professores filtrados.
      </p>

      <DataTable
        title="Professores"
        table={body.table}
        loading={tableLoading}
        onChange={changeTable}
        footnote="Notas são sobre o professor; a avaliação da estrutura da arena fica separada ao lado."
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_2fr]">
        <Panel title="Avaliação da estrutura" subtitle="Quadras, vestiário, atendimento — não entra na nota dos professores">
          <p className="flex items-center gap-2 font-heading text-3xl font-bold text-ink">
            <Star className="h-6 w-6 text-warning" aria-hidden="true" />
            {formatRating(body.structure.average)}
          </p>
          <p className="text-sm text-ink-secondary">{formatCount(body.structure.count)} avaliação(ões) no período</p>
        </Panel>

        <Panel title="Comentários recentes" subtitle="Últimos comentários deixados nas avaliações">
          {body.comments === null ? (
            <p className="text-sm text-ink-secondary">Seu perfil não tem permissão para ver comentários de alunos.</p>
          ) : body.comments.length === 0 ? (
            <p className="text-sm text-ink-secondary">Nenhum comentário no período.</p>
          ) : (
            <ul className="flex flex-col divide-y divide-border/50">
              {body.comments.map((comment) => (
                <li key={comment.id} className="flex gap-3 py-3 first:pt-0">
                  <MessageSquareText className="mt-0.5 h-4 w-4 flex-shrink-0 text-ink-secondary" aria-hidden="true" />
                  <div className="min-w-0">
                    <p className="text-sm text-ink">“{comment.text}”</p>
                    <p className="mt-1 text-xs text-ink-secondary">
                      {formatRating(comment.score)} · {comment.instructor ?? 'Estrutura da arena'} · {formatDate(comment.date)}
                      {comment.author ? ` · ${comment.author}` : ''}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </Panel>
      </div>
    </div>
  );
}
